import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { HelpComponent } from './help.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        HelpComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        TranslateModule
    ],
    exports: [
        HelpComponent
    ]
})
export class HelpModule { }